<div class="flex flex-col items-center text-center pt-[2.5rem] pb-[3rem]">
  <portal-sparkle-cluster variant="welcome" />
  <h2 class="font-semibold text-base text-gray-1100 m-0 mb-2">
    {{ welcomeTitle() }}
  </h2>
  <p
    class="text-xs text-center max-w-[18rem] m-0 leading-relaxed text-gray-700">
    Ask any question you have about your business metrics and the AI assistant
    will help you.
  </p>
</div>

@if (hasPrompts()) {
  <div class="flex flex-col w-full">
    <m-tab-view
      class="panel-starter-tabview"
      [headerSize]="tabHeaderSize"
      [tabPanelHeaders]="tabHeaders()"
      (activeIndexChange)="tabChange.emit($event)">
      <ng-template [mTabIndex]="0" #tabContent>
        <div class="flex flex-col items-stretch w-full gap-2">
          @for (starter of myStarters(); track starter.label) {
            <portal-starter-chip
              [label]="starter.label"
              [disabled]="responding()"
              (clicked)="askStarter.emit(starter)" />
          }
          @if (myStarters().length === 0) {
            <m-empty-states
              class="block mx-auto my-4 text-center"
              [stateType]="EmptyStateType.actionRequired"
              [size]="EmptyStateSize.tiny"
              title="No private prompts yet"
              description="Create an agent in the Agent Hub to add one." />
          }
        </div>
      </ng-template>
      <ng-template [mTabIndex]="1" #tabContent>
        <div class="flex flex-col items-stretch w-full gap-2">
          @for (starter of sharedStarters(); track starter.label) {
            <portal-starter-chip
              [label]="starter.label"
              [disabled]="responding()"
              (clicked)="askStarter.emit(starter)" />
          }
          @if (sharedStarters().length === 0) {
            <m-empty-states
              class="block mx-auto my-4 text-center"
              [stateType]="EmptyStateType.nothingToShow"
              [size]="EmptyStateSize.tiny"
              title="No shared prompts"
              description="Ask a teammate to share an agent with you." />
          }
        </div>
      </ng-template>
    </m-tab-view>
  </div>
} @else if (loading()) {
  <div class="flex flex-col w-full">
    <!-- Tab-strip placeholder: two short bars centered, mimicking the
         "My Prompts | Shared Prompts" m-tab-view header. -->
    <div class="flex justify-center gap-6 mb-6 pointer-events-none">
      <m-skeleton width="5rem" height="1rem"></m-skeleton>
      <m-skeleton width="6rem" height="1rem"></m-skeleton>
    </div>
    <!-- Chip-shaped placeholders: full-width, same height/radius as
         the live <portal-starter-chip> so the load → loaded
         transition doesn't reflow the layout. -->
    <div class="flex flex-col items-stretch w-full gap-2 pointer-events-none">
      <m-skeleton
        width="100%"
        height="2.5rem"
        styleClass="rounded-[0.25rem]"></m-skeleton>
      <m-skeleton
        width="100%"
        height="2.5rem"
        styleClass="rounded-[0.25rem]"></m-skeleton>
      <m-skeleton
        width="100%"
        height="2.5rem"
        styleClass="rounded-[0.25rem]"></m-skeleton>
    </div>
  </div>
} @else {
  <!-- No agents available for this brand. Common causes: (1) the user's
       email doesn't map to a Fleet workspace member, (2) no agents in the
       Fleet workspace are scoped to this client/brand, (3) MIA_PANEL is on
       but the agent rollout hasn't reached this tenant. Panel mount itself
       succeeded — this is informational, not an error. -->
  <m-empty-states
    class="block mx-auto my-6 text-center"
    [stateType]="EmptyStateType.nothingToShow"
    [size]="EmptyStateSize.tiny"
    title="No AI assistants available"
    description="There are no agents enabled for this brand yet. Reach out to your Measured CS team to get started." />
}
